import { useContext, useEffect, useState } from "react";
import TextWithCheckboxField from "../../../../components/textWithCheckboxField/textWithCheckboxField";
import { TextWithCheckBoxFieldProps } from "../../../../components/textWithCheckboxField/types/textWithCheckboxFieldProps";
import KrFormContext, { LandslideBuildingDamage, LandslideRoadDamages, landSlideAttributes, KrFormContextLandslideType, NavHeadingsKROEnum, KrLandslideFormTypes } from "../../../../contexts/krFormContext";
import { configValidation, createConfigValidation } from "../../../../helpers/validation/validation";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import { SelectForTextFieldProps } from "../../../../components/selectForTextField/types/selectForTextFieldProps";
import { iconStyle, styleFormFieldOnFour, styleFormFieldOnThree, styleFormFieldSeventyFive, stylizationVerticalAlign } from "../../../../components/shared/stylization";
import { Option, SelectInputProps } from "../../../../components/shared/selectInput/types/selectInputProps";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { ReactComponent as addCircleIcon } from '../../../../icons/add_circle.svg';
import SelectForTextField from "../../../../components/selectForTextField/selectForTextField";
import { GetOptions } from "../../../../helpers/prepareForSelect";
import ButtonField from "../../../../components/buttonField/buttonField";
import FormField from "../../../../components/formField/formField";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import { ReactComponent as Delete } from "../../../../icons/delete.svg";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { FormSectionProps } from "./shared/types/formSectionProps";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";


type BuildingDamageView = {
    idx?: number,
    uszkodzone?: LandslideBuildingDamage,
    zniszczone?: LandslideBuildingDamage,
    rodzaJ_ZABUDOWY_SID?: number,
    liczba?: number,
    liczba2?: number
}

const ThreatsAndDamage = (props: FormSectionProps) => {

    const checkIfHasValue = (value: string | undefined | null, name?: string) => {
        if (value !== undefined && value !== "" && value !== "Nie stwierdzono" && value !== "Nie występują" && value != null) {
            return false;
        }
        return true;
    }

    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;

    // Dicts
    const dictRodzajZabudowy = GetOptions("RODZAJ_ZABUDOWY", krForm.dictionaries, true);
    const dictRoadCategory = GetOptions("KATEGORIA_DROGI", krForm.dictionaries, true);
    const dictCommInfra = GetOptions("INFRASTRUKTURA_KOMUNIKACYJNA", krForm.dictionaries, true);   

    const descriptionDict: Option[] = [
        { name: 'Wystąpienie dalszych ruchów osuwiskowych jest możliwe szczególnie po długotrwałych lub katastrofalnych opadach atmosferycznych, a także po długotrwałych roztopach oraz w wyniku podcięcia erozyjnego.', value: '1' },
        { name: 'Wystąpienie dalszych ruchów osuwiskowych jest mało prawdopodobne.', value: '2' },
        { name: 'Na osuwisku zostały wykonane prace stabilizacyjne i nie powinno ono wykazywać dalszej aktywności. Istnieje jednak możliwość uaktywnienia się osuwiska w wyniku zmian uwarunkowań geotechnicznych.', value: '3' },
    ]

    const [uprawy, setUprawy] = useState(checkIfHasValue(krForm.landslideAttributes?.szkodY_UPRAWY, "szkodY_UPRAWY"));
    const [pristineUprawy, setPristineUprawy] = useState(true);

    const getZabudowa = (value: string | null | undefined) => {
        if (krForm.landslideBuildingDamages?.length === 0 && (value === "Nie stwierdzono" || !value)) return true
        else return false
    }

    const [zabudowa, setZabudowa] = useState(getZabudowa(krForm.landslideAttributes?.szkodY_ZABUDOWA_OPIS));
    const [pristineZabudowa, setPristineZabudowa] = useState(true);

    const getKomunikacja = (value: string | null | undefined) => {
        if (krForm.landslideRoadDamages?.length === 0 && (value === "Nie stwierdzono" || !value)) return true
        else return false
    }

    const [komunikacja, setKomunikacja] = useState(getKomunikacja(krForm.landslideAttributes?.szkodY_KOMUNIKACJA_OPIS));
    const [pristineKomunikacja, setPristineKomunikacja] = useState(true);

    const [linie, setLinie] = useState(checkIfHasValue(krForm.landslideAttributes?.szkodY_LINIE_PRZESYLOWE, "szkodY_LINIE_PRZESYLOWE"));
    const [pristineLinie, setPristineLinie] = useState(true);

    const [inne, setInne] = useState(checkIfHasValue(krForm.landslideAttributes?.szkodY_INNE, "szkodY_INNE"));
    const [pristineinne, setPristineInne] = useState(true);

    const [zagrozeniaUprawy, setZagrozeniaUprawy] = useState(checkIfHasValue(krForm.landslideAttributes?.zagrozeniA_UPRAWY, "zagrozeniA_UPRAWY"));
    const [pristineZagrozeniaUprawy, setPristineZagrozeniaUprawy] = useState(true);

    const [zagrozeniaZabudowa, setZagrozeniaZabudowa] = useState(checkIfHasValue(krForm.landslideAttributes?.zagrozeniA_ZABUDOWA, "zagrozeniA_ZABUDOWA"));
    const [pristineZagrozeniaZabudowa, setPristineZagrozeniaZabudowa] = useState(true);

    const [zagrozeniaKomunikacja, setZagrozeniaKomunikacja] = useState(checkIfHasValue(krForm.landslideAttributes?.zagrozeniA_KOMUNIKACJA, "zagrozeniA_KOMUNIKACJA"));
    const [pristineZagrozeniaKomunikacja, setPristineZagrozeniaKomunikacja] = useState(true);

    const [zagrozeniaLinie, setZagrozeniaLinie] = useState(checkIfHasValue(krForm.landslideAttributes?.zagrozeniA_LINIE_PRZESYLOWE, "zagrozeniA_LINIE_PRZESYLOWE"));
    const [pristineZagrozeniaLinie, setPristineZagrozeniaLinie] = useState(true);

    const [zagrozeniaInne, setZagrozeniaInne] = useState(checkIfHasValue(krForm.landslideAttributes?.zagrozeniA_INNE, "zagrozeniA_INNE"));
    const [pristineZagrozeniaInne, setPristineZagrozeniaInne] = useState(true);

    const [selectedDescript, setSelectedDescript] = useState(descriptionDict[0]);
    const [description, setDescription] = useState(descriptionDict[0].name);
    const [pristineZagrozeniaOpis, setPristineZagrozeniaOpis] = useState(true);

    const [reload, setReload] = useState<boolean>(false); 

    const isFormNotValid = krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false;

    const buildingDamageDefault: BuildingDamageView[] = [{
        uszkodzone: undefined,
        zniszczone: undefined,
        liczba: undefined,
        liczba2: undefined,
        idx: krForm?.landslideBuildingDamages?.length
    }]

    const roadDamagesDefault: LandslideRoadDamages[] = [{
        infrastrukturA_KOM_SID: undefined,
        dlugosc: undefined,
        idx: krForm.landslideRoadDamages?.length
    }]

    const prepareBuildingDamages = (form?: KrLandslideFormTypes) => {
        var dataBuildingDamage: BuildingDamageView[] = [];
        var element = form ? form : krForm;
        if((element.landslideBuildingDamages && element.landslideBuildingDamages.length > 0)){
            for(var i = 0; i < element.landslideBuildingDamages.length; i++){
                if(element.landslideBuildingDamages[i].rodzaJ_ZABUDOWY_SID){
                    // eslint-disable-next-line no-loop-func
                    var foundData = dataBuildingDamage.find((building) => {
                        if(building.uszkodzone){
                            return building.uszkodzone.rodzaJ_ZABUDOWY_SID === element?.landslideBuildingDamages![i].rodzaJ_ZABUDOWY_SID;
                        }
                        if(building.zniszczone){
                            return building.zniszczone.rodzaJ_ZABUDOWY_SID === element?.landslideBuildingDamages![i].rodzaJ_ZABUDOWY_SID;
                        }
                        return false;
                    })
                    if(foundData){
                        if(element.landslideBuildingDamages[i].rodzaJ_SZKODY_SID === 1){
                            foundData.uszkodzone = element.landslideBuildingDamages[i]
                            foundData.rodzaJ_ZABUDOWY_SID = element.landslideBuildingDamages[i].rodzaJ_ZABUDOWY_SID
                            foundData.liczba = element.landslideBuildingDamages[i].liczba;
                        }
                        if(element.landslideBuildingDamages[i].rodzaJ_SZKODY_SID === 2){
                            foundData.zniszczone = element.landslideBuildingDamages[i]
                            foundData.rodzaJ_ZABUDOWY_SID = element.landslideBuildingDamages[i].rodzaJ_ZABUDOWY_SID
                            foundData.liczba2 = element.landslideBuildingDamages[i].liczba;
                        }
                    }
                    else{
                        if(element.landslideBuildingDamages[i].rodzaJ_SZKODY_SID === 1){
                            dataBuildingDamage.push({
                                idx: i,
                                uszkodzone: element.landslideBuildingDamages[i],
                                liczba: element.landslideBuildingDamages[i].liczba,
                                rodzaJ_ZABUDOWY_SID: element.landslideBuildingDamages[i].rodzaJ_ZABUDOWY_SID
                            })
                        }
                        if(element.landslideBuildingDamages[i].rodzaJ_SZKODY_SID === 2){
                            dataBuildingDamage.push({
                                idx: i,
                                zniszczone: element.landslideBuildingDamages[i],
                                liczba2: element.landslideBuildingDamages[i].liczba,
                                rodzaJ_ZABUDOWY_SID: element.landslideBuildingDamages[i].rodzaJ_ZABUDOWY_SID
                            })
                        }
                    }
                }
                
            }
            return dataBuildingDamage;
        }
        else{
            return [];
        }
    }

    const [buildingDamage, setBuildingDamage] = useState<BuildingDamageView[]>(prepareBuildingDamages())
    const [newBuildingDamage, setNewBuildingDamage] = useState<BuildingDamageView>(buildingDamageDefault[0]);
    const [disableAddBuildingDamageBtn, setDisableAddBuildingDamageBtn] = useState<boolean>(true);
    const [hideAddBuildingDamagePanel, setHideAddBuildingDamagePanel] = useState<boolean>(buildingDamage.length > 5);

    const [roadsDamage, setRoadsDamage] = useState<LandslideRoadDamages[]>
        ((krForm.landslideRoadDamages && krForm.landslideRoadDamages.length > 0) ? krForm.landslideRoadDamages : []);
    const [newRoadDamage, setNewRoadDamage] = useState<LandslideRoadDamages>(roadDamagesDefault[0]);
    const [disableAddRoadDamageBtn, setDisableAddRoadDamageBtn] = useState<boolean>(true);
    const [hideAddRoadDamagePanel, setHideAddRoadDamagePanel] = useState<boolean>(roadsDamage.length > 4);
    
    const [reloadAddBuildingDamageNumericalLiczba, setReloadAddBuildingDamageNumericalLiczba] = useState<boolean>(false);
    const [reloadAddBuildingDamageNumericalLiczba2, setReloadAddBuildingDamageNumericalLiczba2] = useState<boolean>(false);


    useEffect(() => {
        setReloadAddBuildingDamageNumericalLiczba2(!reloadAddBuildingDamageNumericalLiczba2);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newBuildingDamage.liczba]);

    useEffect(() => {
        setReloadAddBuildingDamageNumericalLiczba(!reloadAddBuildingDamageNumericalLiczba);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newBuildingDamage.liczba2]);

    // Textareas with checkbox
    const getTextWithCheckboxFieldProps = (name: string, setElement: Function, element: boolean, labelName: string, pristine: boolean, setPristine: Function, 
        KRFieldDict: KROFieldDict, fieldFormName: string, typeCheckbox?: boolean, configValidation?: any) => {
        var valueCopy = krForm.landslideAttributes ? krForm.landslideAttributes[name as keyof landSlideAttributes] : "";
        // if(name === "szkodY_ZABUDOWA_OPIS"){
        //     if (krForm.landslideBuildingDamages?.length === 0 && (valueCopy === "Nie stwierdzono" || !valueCopy) && zabudowa){
        //         valueCopy = "Nie stwierdzono";
        //     }
        // }

        // if(name === "szkodY_KOMUNIKACJA_OPIS"){
        //     if (krForm.landslideRoadDamages?.length === 0 && (valueCopy === "Nie stwierdzono" || !valueCopy) && komunikacja){
        //         valueCopy = "Nie stwierdzono";
        //     }
        // }
        var textWithCheckboxProps: TextWithCheckBoxFieldProps = {
            textAreaProps: {
                labelName: labelName,
                textAreaPlaceholder: 'Dodaj opis',
                value: valueCopy,
                textareaSharedProps: {
                    className: 'body-txt-large',
                    style: {
                        width: '100%',
                        minHeight: '70px'
                    }
                },
                onFocusText: () => { focusChange(name, setElement, element) },
                setValue: (value: any) => {
                    var form: any = Object.assign({}, krForm);
                    if (form && form.landslideAttributes) {
                        form.landslideAttributes[name] = value;
                        setkrForm(form);
                    }
                },
                configValidation: configValidation ? configValidation : createConfigValidation("onlyRequired"),
                pristine: pristine,
                validationError: isFormNotValid,
                disabled: !props.editMode,
                addCommentBtn: getAddCommentBtnDetails(props.editMode!, KRFieldDict, fieldFormName, props.setNewCommentFieldDetails!),
                textareaRef: (node: any) => {getFieldRef(node, KRFieldDict, props.getMapForComment!)},
                setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KRFieldDict); },
                isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KRFieldDict,
                dynamicResize: true,
                reload: reload
            },
            checkBoxProps: {
                onChange: () => { checkboxChange(name, setElement, element, setPristine, typeCheckbox) },
                labelName: typeCheckbox ? 'Nie występują' : 'Nie stwierdzono',
                inputChecked: element,
                disabled: !props.editMode
            }
        }
        return textWithCheckboxProps;
    }

    const focusChange = (name: string, set: Function, state: boolean) => {
        if (state) {
            var form: any = Object.assign({}, krForm);
            if (form.landslideAttributes) {
                form.landslideAttributes[name as keyof landSlideAttributes] = "";
                setkrForm(form);
            }
            set(!state);
        }
    }

    const checkboxChange = (name: string, set: Function, state: boolean, setPristine: Function, checkboxType?: boolean) => {
        var form = Object.assign({}, krForm);
        if (!state && form !== null && form.landslideAttributes) {
            if (name === "szkodY_ZABUDOWA_OPIS") {
                form.landslideBuildingDamages = [];
                setBuildingDamage([]);
                setkrForm(form);
                setReload(!reload);
            }
            if (name === "szkodY_KOMUNIKACJA_OPIS") {
                form.landslideRoadDamages = [];
                setRoadsDamage([]);
                setkrForm(form);
                setReload(!reload);
            }
            checkboxType ? form.landslideAttributes[name as keyof landSlideAttributes] = "Nie występują" : form.landslideAttributes[name as keyof landSlideAttributes] = "Nie stwierdzono";
            setkrForm(form);
            set(true);
        }
        else {
            if (form.landslideAttributes) {
                form.landslideAttributes[name as keyof landSlideAttributes] = "";
                setkrForm(form);
                set(false);
            }
        }
        setDescription(descriptionDict[0].name);
        setPristine(false);
    }

    // Activity textarea
    var textAreaActivityProps: TextAreaFieldProps = {
        labelName: 'Ocena możliwości wystąpienia dalszych ruchów osuwiskowych',
        textAreaPlaceholder: krForm.landslideAttributes?.dalszE_RUCHY == null || krForm.landslideAttributes?.dalszE_RUCHY === '' ?
            'Dodaj opis' : '',
        value: krForm.landslideAttributes?.dalszE_RUCHY,
        textareaSharedProps: {
            className: krForm.landslideAttributes?.dalszE_RUCHY == null
                || krForm.landslideAttributes?.dalszE_RUCHY === '' ?
                'body-txt-medium-sec-gray' :
                'body-txt-large',
            style: {
                width: '100%',
                minHeight: '70px'
            }
        },
        configValidation: props.collectiveEdition ? undefined : createConfigValidation("dalszE_RUCHY"),
        disabled: !props.editMode,
        pristine: pristineZagrozeniaOpis,
        setValue: (value: any) => {
            var form = Object.assign({}, krForm);
            if (form && form.landslideAttributes) {
                form.landslideAttributes.dalszE_RUCHY = value;
                setkrForm(form);
            }
        },
        validationError: isFormNotValid,
        addCommentBtn: getAddCommentBtnDetails(props.editMode!, KROFieldDict.powstSzkZgr_ocenaMozliwosciWystapieniaDalszychRuchowOsuwiskowych, 'Ocena możliwości wystąpienia dalszych ruchów osuwiskowych', props.setNewCommentFieldDetails!),
        textareaRef: (node: any) => {getFieldRef(node, KROFieldDict.powstSzkZgr_ocenaMozliwosciWystapieniaDalszychRuchowOsuwiskowych, props.getMapForComment!)},
        setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.powstSzkZgr_ocenaMozliwosciWystapieniaDalszychRuchowOsuwiskowych); },
        isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KROFieldDict.powstSzkZgr_ocenaMozliwosciWystapieniaDalszychRuchowOsuwiskowych,
        dynamicResize: true
    }

    // Select with button
    const onClickButton: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        var form: any = Object.assign({}, krForm);
        if (form.landslideAttributes.dalszE_RUCHY == null) {
            form.landslideAttributes.dalszE_RUCHY = "";
        }
        form.landslideAttributes.dalszE_RUCHY += description;
        setkrForm(form);
        setPristineZagrozeniaOpis(false);
    }

    const selectOptionChange = (option: Option | Option[]) => {
        if (option) {
            const opt = option as Option;
            if (opt.name) {
                setDescription(opt.name);
                setSelectedDescript(opt);
            }
        }
    }

    const selectForTextProps: SelectForTextFieldProps = {
        selectInputProps: {
            style: styleFormFieldSeventyFive,
            label: 'Szablon',
            options: descriptionDict,
            selectedSingleOption: selectedDescript,
            onChange: selectOptionChange
        },
        buttonProps: {
            BtnProps: {
                onClick: onClickButton,
                className: classNameBtn.SmallSecondary + " body-txt-medium",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%'
                }
            },
            placeHolder: "Dodaj treść z szablonu",
            placeHolderStyle: {
                paddingLeft: '25px'
            },
            additionalIcon: addCircleIcon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: '28%',
                    display: 'flex',
                    height: '49px',
                    paddingTop: '30.5px'
                }
            }
        }
    }

    // Damages
    const PropsSVG: React.SVGAttributes<SVGSVGElement> = {
        style: iconStyle,
        width: 24,
        height: 24,
        fill: '#999490'
    }

    const getInputProps = (labelName: string, value: any, style: React.CSSProperties, disable: boolean,
        inputPlaceholder?: string, limitInput?: boolean, configValidation?: configValidation, reload?: boolean): FormFieldProps => {
        return {
            labelName: labelName,
            inputPlaceholder: inputPlaceholder,
            value: value,
            style: style,
            type: "text",
            configValidation: configValidation,
            disabled: disable,
            reload: reload,
            onlyDigits: limitInput,
            min: 1
        }
    }

    const getSelectProps = (label: string, placeHolder: string, options: Option[] | undefined, selectedSingleOption: Option | undefined, onChange: Function, 
        style: React.CSSProperties, disable: boolean): SelectInputProps => {
        return {
            label: label,
            placeHolder: placeHolder,
            options: options, 
            selectedSingleOption: selectedSingleOption,
            style: style,
            hasInputTags: false,
            onlySingleTag: false,
            onChange: (option: Option[] | undefined | Option) => { onChange(option) },
            disabled: disable,
            reload: reload
        }
    }

    const getAddDamageBtnProps = (title: string, onClick: Function, disable: boolean, icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>) => {
        return {
            BtnProps: {
                onClick: (e: any) => { onClick(e) },
                style: {
                    width: '100%',
                    height: '49px'
                },
                className: classNameBtn.Small,
                disabled: !props.editMode || disable
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: '23.5%',
                    display: 'flex',
                    paddingTop: '29px'
                }
            }
        };
    }

    // Building damages
    useEffect(() => {
        if (buildingDamage.length > 5 && !hideAddBuildingDamagePanel) setHideAddBuildingDamagePanel(true);
        else {
            var disable = false;
            if (!newBuildingDamage.rodzaJ_ZABUDOWY_SID || (!newBuildingDamage.liczba && !newBuildingDamage.liczba2)) disable = true;
            if (disable !== disableAddBuildingDamageBtn) setDisableAddBuildingDamageBtn(disable);
            if (buildingDamage.length < 6 && hideAddBuildingDamagePanel) setHideAddBuildingDamagePanel(false);
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [buildingDamage, newBuildingDamage])

    const addBuildingDamage = (event: any) => {
        var form = structuredClone(krForm);
        if (form.landslideAttributes && form.landslideAttributes?.szkodY_ZABUDOWA_OPIS === "Nie stwierdzono") {
            form.landslideAttributes.szkodY_ZABUDOWA_OPIS = "";
        }
        setZabudowa(false);
        
        var build = structuredClone(buildingDamage);
        if (form.landslideBuildingDamages) {
            var newRec = structuredClone(newBuildingDamage);
            newRec.idx = build.length;
            build.push(newBuildingDamage);
            var concatAll: LandslideBuildingDamage[] | undefined = []
            for(var i = 0; i < build.length; i++){
                if(build[i] !== undefined && build[i].uszkodzone){
                    build[i].uszkodzone!.liczba = build[i].liczba;
                    concatAll.push(build[i].uszkodzone!)
                }
                if(build[i].zniszczone !== undefined){
                    build[i].zniszczone!.liczba = build[i].liczba2;
                    concatAll.push(build[i].zniszczone!)
                }
            }
            form.landslideBuildingDamages = concatAll;
            setkrForm(form);
            setBuildingDamage(build);
            setNewBuildingDamage(buildingDamageDefault[0]);
            setReload(!reload);
        }
    }

    const renderAddBuildingDamagePanel = () => {
        const getNumericFieldValidation = (secondValue: any): configValidation => {
            return {
                requiredOneOfTwo: {
                    secondValue: secondValue,
                    errorMsg: "Wymagane wskazanie liczby budynków uszkodzonych lub zniszczonych"
                }
            }
        }

        const getDictRodzajZabudowy = () => {
            var filteredDict = dictRodzajZabudowy?.filter(item => !buildingDamage.find(elem => elem.rodzaJ_ZABUDOWY_SID === item.value));
            return filteredDict === undefined ? [] : filteredDict as Option[];
        }

        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%", marginTop: "20px", marginBottom: "20px"}}>
                <SelectInput {...getSelectProps(
                    "Rodzaj zabudowy",
                    "Wybierz rodzaj zabudowy",
                    getDictRodzajZabudowy(),
                    createZabudowaSelect(true),
                    addBuildingDamagePanelSelectOnChange,
                    styleFormFieldOnFour,
                    false
                )} />
                <FormField {...getInputProps(
                    "Budynki uszkodzone", 
                    newBuildingDamage.liczba, 
                    styleFormFieldOnFour,                     
                    false,
                    "Podaj liczbę uszkodzonych budynków",
                    true,
                    getNumericFieldValidation(newBuildingDamage.liczba2),
                    reloadAddBuildingDamageNumericalLiczba)} setValue={(value) => { addBuildingDamagePanelSetValue(value, "liczba") }} debounceOff={true} />
                <FormField {...getInputProps(
                    "Budynki zniszczone",                   
                    newBuildingDamage.liczba2, 
                    styleFormFieldOnFour,                     
                    false,
                    "Podaj liczbę zniszczonych budynków", 
                    true,
                    getNumericFieldValidation(newBuildingDamage.liczba),
                    reloadAddBuildingDamageNumericalLiczba2)} setValue={(value) => { addBuildingDamagePanelSetValue(value, "liczba2") }} debounceOff={true} />
                <ButtonField {...getAddDamageBtnProps("Dodaj szkodę", addBuildingDamage, disableAddBuildingDamageBtn, (props.editMode ? addCircleIcon : undefined))}></ButtonField>
            </div>
        );
    }

    const renderSelectedBuildingDamages = (idx: number) => {
        var showLabels = (!props.editMode || hideAddBuildingDamagePanel) && idx === 0;
        var objects: JSX.Element = <>
            {showLabels && <br/>}
            <div key={idx} style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%"}}>
                <FormField {...getInputProps(
                    showLabels ? "Rodzaj zabudowy" : "",
                    createZabudowaSelect(false, idx)?.name,
                    styleFormFieldOnFour,
                    true
                )} />
                <FormField {...getInputProps(
                    showLabels ? "Budynki uszkodzone" : "",
                    buildingDamage[idx].liczba,
                    styleFormFieldOnFour,
                    true
                )} />
                <FormField {...getInputProps(
                    showLabels ? "Budynki zniszczone" : "",
                    buildingDamage[idx].liczba2,
                    styleFormFieldOnFour,
                    true
                )} />
                <div style={{
                    width: '23.5%',
                    paddingTop: '32px',
                    justifyContent: 'start',
                    display: 'flex'
                }}><Delete title="usuń" className="tableActionsFormIcons" {...PropsSVG} style={showLabels ? {...iconStyle, paddingTop: '10px'} : iconStyle} onClick={(event: any) => { if(props.editMode) deleteBuilding(event, idx) }} /></div>
            </div>
        </>
        return (objects);
    }

    const createZabudowaSelect = (isAddPanel: boolean, idx?: number, ) => {
        var objects = dictRodzajZabudowy?.find((option) => {
            if (isAddPanel) return (option.value === newBuildingDamage.rodzaJ_ZABUDOWY_SID);
            else return (option.value === buildingDamage[idx!].rodzaJ_ZABUDOWY_SID);
        })
        return objects;
    }

    const addBuildingDamagePanelSelectOnChange = (opt: Option[] | undefined | Option) => {
        var newRec = structuredClone(newBuildingDamage);
        newRec.rodzaJ_ZABUDOWY_SID = (opt as Option).value as number
        if (newRec.zniszczone) newRec.zniszczone.rodzaJ_ZABUDOWY_SID = (opt as Option).value as number
        if (newRec.uszkodzone) newRec.uszkodzone.rodzaJ_ZABUDOWY_SID = (opt as Option).value as number        
        setNewBuildingDamage(newRec);     
    }

    const addBuildingDamagePanelSetValue = (value: any, name: string) => {
        var newRec = structuredClone(newBuildingDamage);
        newRec[name as keyof BuildingDamageView] = value;
        if (name === "liczba") {           
            if (newRec.uszkodzone) newRec.uszkodzone.liczba = value; 
            else {
                var uszkodzoneElem: LandslideBuildingDamage = {
                    rodzaJ_ZABUDOWY_SID: newRec.rodzaJ_ZABUDOWY_SID,
                    rodzaJ_SZKODY_SID: 1,
                    liczba: undefined,
                    liczba2: undefined,
                }
                newRec.uszkodzone = uszkodzoneElem;
            }   
        }
        else {
            if (newRec.zniszczone) newRec.zniszczone.liczba = value;
            var zniszczoneElem: LandslideBuildingDamage = {
                rodzaJ_ZABUDOWY_SID: newRec.rodzaJ_ZABUDOWY_SID,
                rodzaJ_SZKODY_SID: 2,
                liczba: undefined,
                liczba2: undefined,
            }
            newRec.zniszczone = zniszczoneElem;
        }
        setNewBuildingDamage(newRec);
    }
    
    const deleteBuilding = (event: any, idx: number) => {
        var zabudowCopy = structuredClone(buildingDamage);
        var deletedElement = zabudowCopy.splice(idx, 1);
        zabudowCopy.forEach((element, idx) => {
            element.idx = idx;
        })
        setBuildingDamage(zabudowCopy);
        var form = structuredClone(krForm);
        if(deletedElement && deletedElement.length > 0 && form.landslideBuildingDamages){
            form.landslideBuildingDamages = form.landslideBuildingDamages.filter((build) => {
                return build.rodzaJ_ZABUDOWY_SID !== deletedElement[0].rodzaJ_ZABUDOWY_SID
            }) 
        }
        if (zabudowCopy.length === 0 && !zabudowa) {
            if (form.landslideAttributes) form.landslideAttributes.szkodY_ZABUDOWA_OPIS = "Nie stwierdzono";
            setZabudowa(true);
        }
        setkrForm(form);
        setReload(!reload);
    }

    // Road damages
    useEffect(() => {
        setReload(!reload);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.roadCategories, krForm.landslideAttributes?.kolej])

    useEffect(() => {
        if (roadsDamage.length > 4 && !hideAddRoadDamagePanel) setHideAddRoadDamagePanel(true);
        else {
            var disable = false;
            if (!newRoadDamage.infrastrukturA_KOM_SID || !newRoadDamage.dlugosc) disable = true;
            if (disable !== disableAddRoadDamageBtn) setDisableAddRoadDamageBtn(disable);
            if (roadsDamage.length < 5 && hideAddRoadDamagePanel) setHideAddRoadDamagePanel(false);
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roadsDamage, newRoadDamage])

    const addRoadDamage = (event: any) => {
        var form = structuredClone(krForm);
        if (form.landslideAttributes && form.landslideAttributes?.szkodY_KOMUNIKACJA_OPIS === "Nie stwierdzono") {
            form.landslideAttributes.szkodY_KOMUNIKACJA_OPIS = "";
        }
        setKomunikacja(false);
        
        var build = structuredClone(roadsDamage);
        if (form.landslideRoadDamages) {
            build.push(newRoadDamage);
            form.landslideRoadDamages = build;
            setkrForm(form);
            setRoadsDamage(form.landslideRoadDamages);
            setNewRoadDamage(roadDamagesDefault[0]);
            setReload(!reload);
        }
    }

    const renderAddRoadDamagePanel = () => {
        var selectedRoad = dictCommInfra?.find((option) => {
            return option.value === newRoadDamage.infrastrukturA_KOM_SID
        });
        var validationError = !checkRoadAvailability(selectedRoad);

        const getDictKategoriaDrogi = () => {
            var filteredDict = dictCommInfra?.filter(item => !roadsDamage.find(elem => elem.infrastrukturA_KOM_SID === item.value) && item.name !== "brak");
            return filteredDict === undefined ? [] : filteredDict as Option[];
        }

        const reloadConfigValidation = () => {
            var comparedValues = {
                roadCategories: krForm.roadCategories,
                kolej: krForm.landslideAttributes?.kolej
            }
            return createConfigValidation("roadDamages", false, comparedValues, undefined, undefined, 
                [dictRoadCategory ? dictRoadCategory : [], dictCommInfra ? dictCommInfra : []]
            )
        }
        
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%", marginTop: "20px", marginBottom: "20px"}}>
                <SelectInput {...getSelectProps(
                    "Rodzaj infrastruktury",
                    "Wybierz rodzaj infrastruktury",
                    getDictKategoriaDrogi(),
                    selectedRoad,
                    addRoadDamagePanelSelectOnChange,
                    styleFormFieldOnThree,
                    false
                )} 
                configValidation={reload ? reloadConfigValidation() : reloadConfigValidation()}
                validationError={validationError} />
                <FormField {...getInputProps(
                    "Długość uszkodzenia [m]",
                    newRoadDamage.dlugosc,
                    styleFormFieldOnThree,
                    false,
                    "Podaj długość uszkodzenia",
                    true
                )} setValue={(value) => { addRoadDamagePanelSetValue(value, "dlugosc") }} debounceOff={true} />
                <ButtonField {...getAddDamageBtnProps("Dodaj szkodę", addRoadDamage, disableAddRoadDamageBtn, (props.editMode ? addCircleIcon : undefined))}></ButtonField>
            </div>
        );
    }

    const renderSelectedRoadDamages = (idx: number) => {
        var showLabels = (!props.editMode || hideAddRoadDamagePanel) && idx === 0;
        var selectedRoad = dictCommInfra?.find((option) => {
            return option.value === roadsDamage[idx].infrastrukturA_KOM_SID
        });
        var validationError = !checkRoadAvailability(selectedRoad);

        const reloadConfigValidation = () => {
            var comparedValues = {
                roadCategories: krForm.roadCategories,
                kolej: krForm.landslideAttributes?.kolej
            }
            return createConfigValidation("roadDamages", false, comparedValues, undefined, undefined, 
                [dictRoadCategory ? dictRoadCategory : [], dictCommInfra ? dictCommInfra : []]
            )
        }

        var objects: JSX.Element = <>
            {showLabels && <br/>}
            <div key={idx} style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%"}}>
                <SelectInput {...getSelectProps(
                    showLabels ? "Rodzaj infrastruktury" : "",
                    "",
                    [],
                    selectedRoad,
                    () => {},
                    styleFormFieldOnThree,
                    true
                )} 
                configValidation={reload ? reloadConfigValidation() : reloadConfigValidation()}
                validationError={validationError} 
                />
                <FormField {...getInputProps(
                    showLabels ? "Długość uszkodzenia [m]" : "",
                    roadsDamage[idx].dlugosc,
                    styleFormFieldOnThree,
                    true
                )} />
                <div style={{
                    width: '23.5%',
                    paddingTop: '30px',
                    justifyContent: 'start',
                    display: 'flex'
                }}><Delete title="usuń" className="tableActionsFormIcons" {...PropsSVG} style={showLabels ? {...iconStyle, paddingTop: '10px'} : iconStyle} onClick={(event: any) => { if(props.editMode) deleteRoad(event, idx) }} /></div>
            </div>
        </>
        return (objects);
    }

    const checkRoadAvailability = (opt: Option[] | undefined | Option) => {
        if (opt !== undefined) {
            var option = Array.isArray(opt) ? (opt as Option[])[0] : (opt as Option);
            if (option.name?.toLowerCase().includes('kolej')) return krForm.landslideAttributes?.kolej === 1;
            return krForm.roadCategories?.find(item => option.name?.toLowerCase().includes(dictRoadCategory?.find(elem => elem.value === item.kategoriA_DROGI_SID)?.name?.toLowerCase()!)) !== undefined;
        }
        else return true;
    }

    const addRoadDamagePanelSetValue = (value: any, name: string) => {
        var newRec = structuredClone(newRoadDamage);
        newRec[name as keyof LandslideRoadDamages] = value;
        setNewRoadDamage(newRec);
    }

    const addRoadDamagePanelSelectOnChange = (opt: Option[] | undefined | Option) => {
        var newRec = structuredClone(newRoadDamage);
        newRec.infrastrukturA_KOM_SID = (opt as Option).value as number       
        setNewRoadDamage(newRec);     
    }
    
    const deleteRoad = (event: any, idx: number) => {
        var RoadCopy = structuredClone(roadsDamage);
        RoadCopy.splice(idx, 1);
        RoadCopy.forEach((element, idx) => {
            element.idx = idx;
        })
        setRoadsDamage(RoadCopy);
        var form = structuredClone(krForm);
        form.landslideRoadDamages = RoadCopy;
        if (RoadCopy.length === 0 && !komunikacja) {
            if (form.landslideAttributes) form.landslideAttributes.szkodY_KOMUNIKACJA_OPIS = "Nie stwierdzono";
            setKomunikacja(true);
        }
        setkrForm(form);
        setReload(!reload);
    }

    if (props.collectiveEdition) {
        return (
            <>
                <h2 style={{ width: '100%' }}>10. Powstałe szkody i zagrożenia</h2>
                <CollectiveSelectField top={true} value={krForm.landslideAttributes?.dalszE_RUCHY} isAuto={false} title={"Ocena możliwości wystąpienia dalszych ruchów osuwiskowych"}
                    forms={props.forms} keyName={CollectivePreviewKey.ocenaMozliwosci} actions={props.actions} single={false}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <TextAreaField {...textAreaActivityProps} />
                </CollectiveSelectField>
                <div className='collective-input-container collective-block'>
                    <SelectForTextField {...selectForTextProps} />
                </div>
            </>
        )
    }

    return (
        <>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.ThreatsAndDamage, props.getMapForNavScroll!)} style={{ width: '100%' }}>10. Powstałe szkody i zagrożenia</h2>
            <h3>Szkody</h3>
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("szkodY_UPRAWY", setUprawy, uprawy, "Uprawy", pristineUprawy, setPristineUprawy, KROFieldDict.powstSzkZgr_szk_uprawy, "Uprawy - Szkody")} />
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("szkodY_ZABUDOWA_OPIS", setZabudowa, zabudowa, "Zabudowa", pristineZabudowa, 
                setPristineZabudowa, KROFieldDict.powstSzkZgr_szk_zabudowa, "Zabudowa - Szkody", undefined, createConfigValidation("szkodY_ZABUDOWA_OPIS", undefined, krForm.landslideBuildingDamages))} />           
            <div style={{ width: '100%', marginBottom: '30px' }}>
                {props.editMode && !hideAddBuildingDamagePanel && renderAddBuildingDamagePanel()}
                {reload ? buildingDamage?.map((option, idx) => {
                    return renderSelectedBuildingDamages(idx);
                }) : <>{buildingDamage?.map((option, idx) => {
                    return renderSelectedBuildingDamages(idx);
                })}</>}
            </div>
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("szkodY_KOMUNIKACJA_OPIS", setKomunikacja, komunikacja, "Infrastruktura komunikacyjna", 
                pristineKomunikacja, setPristineKomunikacja, KROFieldDict.powstSzkZgr_szk_infrastrukturaKomunikacyjna, 
                "Infrastruktura komunikacyjna - Szkody", undefined, createConfigValidation("szkodY_KOMUNIKACJA_OPIS", undefined, krForm.landslideRoadDamages))} />
            <div style={{ width: '100%', marginBottom: '30px' }}>
                {props.editMode && !hideAddRoadDamagePanel  && renderAddRoadDamagePanel()}
                {reload ? roadsDamage?.map((option, idx) => {
                    return renderSelectedRoadDamages(idx);
                }) : <>{roadsDamage?.map((option, idx) => {
                    return renderSelectedRoadDamages(idx);
                })}</>}
            </div>
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("szkodY_LINIE_PRZESYLOWE", setLinie, linie, "Linie przesyłowe", pristineLinie, setPristineLinie, KROFieldDict.powstSzkZgr_szk_liniePrzesylowe, "Linie przesyłowe - Szkody")} />
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("szkodY_INNE", setInne, inne, "Inne", pristineinne, setPristineInne, KROFieldDict.powstSzkZgr_szk_inne, "Inne - Szkody")} />
            <h3>Zagrożenia</h3>
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("zagrozeniA_UPRAWY", setZagrozeniaUprawy, zagrozeniaUprawy, "Uprawy", pristineZagrozeniaUprawy, setPristineZagrozeniaUprawy, KROFieldDict.powstSzkZgr_zgr_uprawy, "Uprawy - Zagrożenia", true)} />
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("zagrozeniA_ZABUDOWA", setZagrozeniaZabudowa, zagrozeniaZabudowa, "Zabudowa", pristineZagrozeniaZabudowa, setPristineZagrozeniaZabudowa, KROFieldDict.powstSzkZgr_zgr_zabudowa, "Zabudowa - Zagrożenia", true)} />
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("zagrozeniA_KOMUNIKACJA", setZagrozeniaKomunikacja, zagrozeniaKomunikacja, "Infrastruktura komunikacyjna", pristineZagrozeniaKomunikacja, setPristineZagrozeniaKomunikacja, KROFieldDict.powstSzkZgr_zgr_infrastrukturaKomunikacyjna, "Infrastruktura komunikacyjna - Zagrożenia", true)} />
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("zagrozeniA_LINIE_PRZESYLOWE", setZagrozeniaLinie, zagrozeniaLinie, "Linie przesyłowe", pristineZagrozeniaLinie, setPristineZagrozeniaLinie, KROFieldDict.powstSzkZgr_zgr_liniePrzesylowe, "Linie przesyłowe - Zagrożenia", true)} />
            <TextWithCheckboxField {...getTextWithCheckboxFieldProps("zagrozeniA_INNE", setZagrozeniaInne, zagrozeniaInne, "Inne", pristineZagrozeniaInne, setPristineZagrozeniaInne, KROFieldDict.powstSzkZgr_zgr_inne, "Inne - Zagrożenia", true)} />
            <TextAreaField {...textAreaActivityProps} />
            {props.editMode && <SelectForTextField {...selectForTextProps} />}
        </>
    )
}

export default ThreatsAndDamage;